import { isDate, keys } from 'lodash'

export const kbToMb = (kb: number): number => (kb <= 0 ? 0 : kb / 1_000_000)

export const isEllipsisActive = (e: HTMLElement | null): boolean => (e && e.offsetWidth < e.scrollWidth) as boolean

/**
 ** Utility function which helps on detecting if a value is empty or not
 ** Lodash isEmpty has different results for boolean, numbers, date
 */
export const isEmptyValue = (
  value: undefined | null | number | Record<string, unknown> | string | boolean,
): boolean => {
  return (
    value === undefined ||
    value === null ||
    (typeof value === 'number' && isNaN(value)) ||
    (typeof value === 'object' && !isDate(value) && keys(value).length === 0) ||
    (typeof value === 'string' && value.trim().length === 0)
  )
}
export const getEnumKeyByEnumValue = (myEnum: { [k: string]: string }, enumValue: string): string | undefined => {
  const keys = Object.keys(myEnum).filter((x) => myEnum[x] == enumValue)
  return keys.length > 0 ? keys[0] : undefined
}

export const getEnumValueFromKey = (myEnum: { [k: string]: string }, enumKey: string): string | undefined => {
  return myEnum[enumKey]
}

// This value represents the maximum value in C# as integer32
// In the claims api, the limit is defined as integer32
export const dotNetInteger32 = 2_147_483_647

export const convertCamelCaseToHyphen = (value: string) => value.replace(/[A-Z]/g, (m) => '-' + m.toLowerCase())

export const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,18}$/i
